import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const TotalVaccinationByStrategy = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <Donut
            title={'Vacinas aplicadas por estratégia de vacinação'}
            subtitles={chartData?.totalVaccinationByStrategy?.map((item) => item.description)}
            chartData={chartData?.totalVaccinationByStrategy || []}
            colors={defaultColors.slice(0, chartData?.totalVaccinationByStrategy?.length) || []}
            height={300}
        />
    );
};
